/**
 * Visitor pattern implementation for converting gradient AST back to CSS string
 */
const visitor = {
  'visit_linear-gradient'(node) {
    return this.visit_gradient(node);
  },

  'visit_repeating-linear-gradient'(node) {
    return this.visit_gradient(node);
  },

  'visit_radial-gradient'(node) {
    return this.visit_gradient(node);
  },

  'visit_repeating-radial-gradient'(node) {
    return this.visit_gradient(node);
  },

  'visit_conic-gradient'(node) {
    return this.visit_gradient(node);
  },

  visit_gradient(node) {
    let orientation = this.visit(node.orientation);
    if (orientation) {
      orientation += ', ';
    }
    return node.type + '(' + orientation + this.visit(node.colorStops) + ')';
  },

  visit_shape(node) {
    let result = node.value;
    const at = this.visit(node.at);
    const style = this.visit(node.style);

    if (style) {
      result += ' ' + style;
    }
    if (at) {
      result += ' at ' + at;
    }
    return result;
  },

  'visit_default-radial'(node) {
    const at = this.visit(node.at);
    return at || '';
  },

  'visit_extent-keyword'(node) {
    let result = node.value;
    const at = this.visit(node.at);

    if (at) {
      result += ' at ' + at;
    }
    return result;
  },

  'visit_position-keyword'(node) {
    return node.value;
  },

  visit_position(node) {
    return this.visit(node.value.x) + ' ' + this.visit(node.value.y);
  },

  visit_conic(node) {
    let result = '';
    if (node.value) {
      result += 'from ' + node.value + 'deg';
    }
    if (node.position) {
      if (result) result += ' ';
      result += 'at ' + this.visit(node.position.x) + ' ' + this.visit(node.position.y);
    }
    return result;
  },

  'visit_%'(node) {
    return node.value + '%';
  },

  visit_em(node) {
    return node.value + 'em';
  },

  visit_px(node) {
    return node.value + 'px';
  },

  visit_literal(node) {
    return this.visit_color(node.value, node);
  },

  visit_hex(node) {
    return this.visit_color('#' + node.value, node);
  },

  visit_rgb(node) {
    return this.visit_color('rgb(' + node.value.join(', ') + ')', node);
  },

  visit_rgba(node) {
    return this.visit_color('rgba(' + node.value.join(', ') + ')', node);
  },

  visit_color(resultColor, node) {
    let result = resultColor;
    const length = this.visit(node.length);

    if (length) {
      result += ' ' + length;
    }
    return result;
  },

  visit_angular(node) {
    return node.value + 'deg';
  },

  visit_directional(node) {
    return 'to ' + node.value;
  },

  visit_array(elements) {
    return elements
      .map((element, i) => {
        const result = this.visit(element);
        return i < elements.length - 1 ? result + ', ' : result;
      })
      .join('');
  },

  visit(element) {
    if (!element) {
      return '';
    }

    if (Array.isArray(element)) {
      return this.visit_array(element);
    }

    if (element.type) {
      const nodeVisitor = this['visit_' + element.type];
      if (nodeVisitor) {
        return nodeVisitor.call(this, element);
      } else {
        throw Error('Missing visitor visit_' + element.type);
      }
    }

    throw Error('Invalid node.');
  },
};

/**
 * Convert gradient AST to CSS string
 * @param {Object|Array} ast - Gradient AST node or array of nodes
 * @returns {string} CSS gradient string
 */
export function stringify(ast) {
  return visitor.visit(ast);
}
